import { v4 as uuidv4 } from 'uuid';

export const IDEMPOTENCY_KEY_HEADER = 'idempotency-key' as const;

export type IdempotencySubmission = {
  fingerprint: string;
  key: string;
};

export const createIdempotencyKey = (): string => uuidv4();

export const createIdempotencyHeaders = (
  key: string,
): Record<typeof IDEMPOTENCY_KEY_HEADER, string> => ({
  [IDEMPOTENCY_KEY_HEADER]: key,
});

export const generateFingerprint = (value: unknown): string => JSON.stringify(value)!;

export const ensureIdempotencySubmission = (
  current: IdempotencySubmission | null,
  fingerprint: string,
): IdempotencySubmission => {
  if (current?.fingerprint === fingerprint) {
    return current;
  }

  return {
    fingerprint,
    key: createIdempotencyKey(),
  };
};
